<template>
    <div class="property-card">
        <a :href="ad.url" target="_blank" @click="openAdPage(ad, $event)">
            <div class="glide" :class="'carousel' + ad.id">
                <div class="glide__track" data-glide-el="track">
                    <div class="glide__slides">
                        <div class="property-image glide__slide"
                            v-bind:key="ind" v-for="(photo, ind) in ad.photos"
                            :style="{ background: 'url('+ photo.url +') center center / cover no-repeat' }">
                        </div>
                    </div>
                </div>
                <div class="glide__arrows" data-glide-el="controls">
                    <button class="glide__arrow glide__arrow--left" data-glide-dir="<"><i class="fas fa-chevron-left"></i></button>
                    <button class="glide__arrow glide__arrow--right" data-glide-dir=">"><i class="fas fa-chevron-right"></i></button>
                </div>
                <div class="glide__bullets" data-glide-el="controls[nav]">
                    <button v-bind:key="ind" v-for="(photo, ind) in ad.photos" class="glide__bullet" :data-glide-dir="'=' + ind"></button>
                </div>
                <span v-if="ad.promotion_tag" class="promotion-tag" :class="ad.promotion_tag.color">
                    <i :class="ad.promotion_tag.icon"></i>{{ ad.promotion_tag.name }}
                </span>
                <favorite-button :fk_property="ad.id" :is_favorite="ad.is_favorite" inline-template>
                    <div>
                        <a @click.prevent="setFavorite()" href="#" class="property-favorite waves-effect waves-light">
                            <i class="fa-heart fa-2x text-danger" v-bind:class="icon"></i>
                        </a>
                    </div>
                </favorite-button>
            </div>

            <div class="property-content">
                <div class="listingInfo">
                    <div class="price_row">
                        <h5 class="text-success m-t-0">{{ ad.rent_price }} {{$t('per_month')}}</h5>
                    </div>
                    <div class="">
                        <h3 class="text-overflow text-dark">{{ truncate(ad.title, 40) }}</h3>
                        <p class="text-muted text-overflow"><i class="fas fa-map-marker-alt m-r-5"></i>{{ ad.location }}</p>

                        <div class="row">
                            <div class="col-xs-12">
                                <p class="description font-13 text-muted m-b-0" v-html="truncate(ad.description, 150)"></p>
                            </div>
                        </div>

                        <div class="row m-t-20">
                            <div class="col-xs-12 property-action">
                                <span v-if="ad.gender == 'M'" class="icons" data-toggle="tooltip" data-placement="top" :title="$t('just_for_men')">
                                    <i class="fas fa-male"></i>
                                    <span>{{ $t("for_men") }}</span>
                                </span>
                                <span v-if="ad.gender == 'F'" class="icons" data-toggle="tooltip" data-placement="top" :title="$t('just_for_women')">
                                    <i class="fas fa-female"></i>
                                    <span>{{ $t("for_women") }}</span>
                                </span>
                                <span v-if="ad.gender == null" class="icons" data-toggle="tooltip" data-placement="top" :title="$t('available_both')">
                                    <i class="fas fa-restroom"></i>
                                    <span>{{ $t("any_gender") }}</span>
                                </span>
                                <span class="icons pull" data-toggle="tooltip" data-placement="top" :title="$t('bedrooms')"><i class="fas fa-bed m-r-10"></i><span>{{ ad.bedrooms }}</span></span>
                                <span class="icons" data-toggle="tooltip" data-placement="top" :title="$t('bathrooms')"><i class="fa fa-bath m-r-10"></i><span>{{ ad.bathrooms }}</span></span>
                            </div>
                            <!-- <a :href="ad.url" @click="registerVisit(ad.id)" target="_blank" class="btn btn-success btn-block btn-bordered waves-effect waves-light pull-right">{{ $t("see_details") }}</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<i18n src="../../../lang/components/search/property-ad-card.json"></i18n>

<script>
import Glide, { Controls, Swipe } from '@glidejs/glide/dist/glide.modular.esm'
export default {
    props: ['ad', 'index'],
    methods: {
        openAdPage(property_ad, ev) {
            let class_list = ev.target.classList;
            if (class_list.contains('glide__arrow') ||
                class_list.contains('glide__bullet') ||
                class_list.contains('fa-chevron-right') ||
                class_list.contains('fa-chevron-left')) {
                    ev.preventDefault();
                    return;
            }
            this.registerVisit(property_ad.id, this.index);
        },
        truncate: function(string, value) {
            if (string.length > value)
                return string.substring(0 , value) + '...';
            else
                return string;
        },
        registerVisit(property_id) {
            let data = {
                fk_log: null,
                index: this.index,
            }
            axios.post('/property/record-visit/' + property_id, data);
        }
    },
    mounted() {
        new Glide('.carousel' + this.ad.id,
            {
                'animationDuration': 800,
                'rewind': false,
                'gap': 0
            })
                .mount({ Controls, Swipe })
                .on('run', () => {
                    gtag('event', 'change-photo-gallery', {
                        'event_category': 'search-page',
                        'event_label': 'ad-' + this.index,
                    });
                });


        $('[data-toggle="tooltip"]').tooltip({container: 'body'});
    }
}
</script>

<style lang="scss" scoped>
    .glide:not(:hover) {
        .glide__arrows {
            opacity: 0;
        }
    }

    .glide__arrow--disabled {
        opacity: 0;
    }

    .glide__arrow {
        background-color: #FFF;
        color: #555;
        border-radius: 50%;
    }
    .property-card {
        cursor: pointer;
    }

    .promotion-tag {
        padding: 5px 7px;
        border-radius: 3px;
        top: 10px;
        left: 10px;
        position: absolute;

        i {
            margin-right: 5px;
        }

        &.danger {
            background-color: #f5707a;
            color: #FFF;
        }

        &.default {
            background-color: #FFF;
            color: #505458;
        }
    }

</style>
